import Button from '../Buttons/Button';
import '../styles.css'
import { MdArrowForward } from 'react-icons/md';
import { Link } from 'react-router-dom';

interface IDynamicBannerCard {
    title: string,
    text: string,
    icon: string,
    buttonLabel: string,
    buttonUrl: string,
}

const DynamicBannerCard = ({
    title,
    text,
    icon,
    buttonLabel = "Ver",
    buttonUrl = "#",
}: IDynamicBannerCard) => {
    return (
        <>
            <div className='w-[20.5rem] sm:w-[33.5rem] md:w-[53.563rem] lg:w-[55rem] xl:w-[70.5rem] rounded-sm relative bg-brand-green-15'>
                <div className="w-full lg:max-xl:w-[55rem] relative rounded-sm overflow-hidden" >
                    <div className='h-full flex flex-col-reverse md:flex-row justify-between items-start md:items-center px-8 py-10 gap-4'>
                        <div className='w-full md:w-[80%]'>
                            <h3 className='text-tlarge text-primary-100'>{title}</h3>
                            <h4 className='text-primary-100 text-bmedium mt-2 mb-4'>{text}</h4>
                            <Link to={buttonUrl}>
                                <Button
                                    label={buttonLabel}
                                    icon={MdArrowForward}
                                    as='button'
                                    variant='outline-orange'
                                    className='bg-primary-100'
                                />
                            </Link>
                        </div>
                        <img src={icon} alt="icon-file" className='w-[3.75rem] h-[3.75rem] md:w-[5.8125rem] md:h-[5.8125rem]' />
                    </div>
                </div>
            </div>
        </>
    )
};

export default DynamicBannerCard;